import { CATEGORIES, IPHONE_SPECS } from "@/lib/store";
import { ORDER_CATALOG, fullName } from "@/lib/orderCatalog";
import { STOCK_IPHONES, stockIphoneSpec } from "@/lib/stockCatalog";

// Aparelhos aceitos na troca. Mac/iPad/Watch com mais de um tamanho viram um modelo por tamanho (o valor muda).
export const TRADE_CATEGORIES = CATEGORIES.filter((c) => c.id !== "acessorios");
export const NO_STORAGE = "único";
export const BATTERY_MIN = 82;

const allOptions = (entry, field) => {
  const def = entry.fields?.[field];
  if (!def) return [];
  return Array.isArray(def) ? def : [...new Set(Object.values(def.map).flat())];
};

export const tradeModels = (category) => {
  if (category === "iphone") {
    return STOCK_IPHONES.map((name) => ({ name, group: "iPhone", ...stockIphoneSpec(name) }));
  }
  return (ORDER_CATALOG[category] || []).flatMap((entry) => {
    const base = { group: entry.group, storages: allOptions(entry, "storage"), colors: allOptions(entry, "color") };
    const sizes = allOptions(entry, "size");
    return sizes.length > 1 ? sizes.map((size) => ({ ...base, name: fullName(entry, { size }) })) : [{ ...base, name: fullName(entry, { size: sizes[0] }) }];
  });
};

export const hasBattery = (category) => category !== "airpods";

const BOTH = [["novo", "Novo • Lacrado"], ["seminovo", "Seminovo"]];
// Opções de encomenda (Fazer pedido) com faixa de preço: iPhones por modelo; Mac/iPad/Watch/AirPods um por tamanho.
export const orderModels = (category) => (category === "iphone"
  ? Object.keys(IPHONE_SPECS).reverse().map((name) => ({ name, group: "iPhone", storages: IPHONE_SPECS[name].storages, conditions: IPHONE_SPECS[name].sealed ? BOTH : BOTH.slice(1) }))
  : tradeModels(category).map((m) => ({ name: m.name, group: m.group, storages: m.storages?.length ? m.storages : [NO_STORAGE], conditions: BOTH })));

export const TRADE_PARTS = [
  ["tela", "Tela"],
  ["bateria", "Bateria"],
  ["camera_traseira", "Câmera traseira"],
  ["camera_frontal", "Câmera frontal"],
  ["outra", "Outra peça"],
];

export const DEDUCTIONS = [
  ["battery", `Bateria abaixo de ${BATTERY_MIN}%`],
  ["screen", "Tela trincada"],
  ["back", "Tampa traseira trincada"],
  ["marks_light", "Marcas de uso leves"],
  ["marks_moderate", "Marcas de uso moderadas"],
  ["marks_severe", "Marcas de uso severas"],
  ["no_box", "Sem caixa"],
  ["unknown_part", 'Aparece "Peça desconhecida"'],
  ...TRADE_PARTS.map(([id, label]) => [`part_${id}`, `Peça trocada: ${label.toLowerCase()}`]),
];
const LABEL = Object.fromEntries(DEDUCTIONS);
const MARK_KEY = { leves: "marks_light", moderadas: "marks_moderate", severas: "marks_severe" };
// "Sim" sem escolher nenhuma peça conta como "outra" (igual ao servidor).
export const replacedParts = (f) => (f.parts_replaced ? ([...new Set(f.parts || [])].length ? [...new Set(f.parts)] : ["outra"]) : []);

// Mesma conta do servidor: valor do modelo/GB menos os descontos, mais o bônus se foi comprado na RC. null = sem valor cadastrado.
export const estimateTrade = (priceDoc, f, bonus = 0) => {
  const base = priceDoc?.values?.[f.storage || NO_STORAGE];
  if (!base) return null;
  const ded = priceDoc.deductions || {};
  const battery = f.battery === "" || f.battery == null ? null : Number(f.battery);
  const hits = [
    battery != null && battery < BATTERY_MIN ? "battery" : null,
    f.screen_cracked ? "screen" : null,
    f.back_cracked ? "back" : null,
    MARK_KEY[f.marks] || null,
    f.has_box === false ? "no_box" : null,
    f.unknown_part ? "unknown_part" : null,
    ...replacedParts(f).map((p) => `part_${p}`),
  ];
  const lines = hits.filter((k) => k && ded[k]).map((k) => ({ key: k, label: LABEL[k], amount: ded[k] }));
  const extra = f.bought_at_rc && bonus > 0 ? bonus : 0;
  return { base, deductions: lines, bonus: extra, value: Math.max(0, base - lines.reduce((s, x) => s + x.amount, 0)) + extra };
};
